module.exports = new __parcel__URL__("basic-phrases-words.cdbb4581.mp4").toString();